module.exports = __webpack_public_path__ + "static/media/bgait.d8f7c78f.svg";